document.addEventListener("DOMContentLoaded", function () {
  const grid = document.getElementById("masonry-grid");
  const loadMoreBtn = document.getElementById("load-more");

  // Exit if essential elements don't exist
  if (!grid || !loadMoreBtn) return;

  const items = document.querySelectorAll(".grid-item-wrapper");
  const itemsPerLoad = 3;
  let currentlyShown = 3;
  let msnry;

  // Initialize Masonry once
  if (typeof Masonry !== "undefined" && typeof imagesLoaded !== "undefined") {
    imagesLoaded(grid, function () {
      msnry = new Masonry(grid, {
        itemSelector: ".grid-item",
        percentPosition: true,
        gutter: 24,
      });
    });
  } else {
    console.warn("Masonry or imagesLoaded not available");
  }

  // Hide items beyond the initial count
  for (let i = currentlyShown; i < items.length; i++) {
    items[i].classList.add("hidden");
  }

  // Show load more button only if there are more items to show
  if (currentlyShown >= items.length) {
    loadMoreBtn.style.display = "none";
  }

  loadMoreBtn.addEventListener("click", function () {
    // Calculate the end index for the next batch
    const endIndex = Math.min(currentlyShown + itemsPerLoad, items.length);

    // Show the next batch of items
    for (let i = currentlyShown; i < endIndex; i++) {
      items[i].classList.remove("hidden");
    }

    // Update the count of currently shown items
    currentlyShown = endIndex;

    // Hide the button if all items are now shown
    if (currentlyShown >= items.length) {
      loadMoreBtn.style.display = "none";
    }

    // Update Masonry layout to account for the newly visible items
    if (msnry) {
      // Wait for images to load in the newly revealed items
      imagesLoaded(grid, function () {
        msnry.layout();
      });
    } else if (window.initMasonry) {
      // Fallback to the global initMasonry function if available
      window.initMasonry();
    }
  });
});
